import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBRow, MDBCol, MDBDataTable    } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modaladdexpertbn from './Modaladdexpertbn';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaleditexpertbn from './Modaleditexpertbn';





export default class superadminlistexpertbn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
          //  presentype:[],
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
       // this.presentypelist = this.presentypelist.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectexpertbnforadmin')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);
        // this.presentypelist();

    }

      list() {

        setTimeout(() => {
          api.get('registercon/selectexpertbnforadmin')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }





    render() {

      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อ-นามสกุล',
            field: 'name_expert',
            sort: 'name_expert',
            width: 150
          },
          {
            label: 'Username',
            field: 'username_expert',
            sort: 'username_expert',
            width: 150
          },
          {
            label: 'Password',
            field: 'password_expert',
            sort: 'password_expert',
            width: 150
          },
          {
            label: 'สังกัดหน่วยงาน',
            field: 'affiliation_expert',
            sort: 'affiliation_expert',
            width: 150
          },
          {
            label: 'ความเชียวชาญ',
            field: 'expertise_expert',
            sort: 'expertise_expert',
            width: 150
          },
          {
            label: 'เบอร์โทร',
            field: 'tel_expert',
            sort: 'tel_expert',
            width: 150
          },
          {
            label: 'ประเภท',
            field: 'group_expert',
            sort: 'group_expert',
            width: 150
          },
          {
            label: 'ผู้เพิ่มข้อมูล/อัพเดท',
            field: 'name_admin',
            sort: 'name_admin',
            width: 150
          },
          {
            label: 'จัดการ',
            field: 'name_admin1',
            sort: 'name_admin1',
            width: 150
          },
      
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
          {
             list: <>{i+1}</>,
             name_expert: <>{data.name_expertbn}</>,
             username_expert: <>{data.username_expertbn}</>,
             password_expert: <>{data.password_expertbn}</>,
             affiliation_expert: <>{data.affiliation_expertbn}</>,
             expertise_expert: <>{data.expertise_expertbn}</>,
             tel_expert: <>{data.tel_expertbn}</>,
             group_expert: <>{data.presentype_name}</>,
             name_admin: <>{data.name_admin}</>,
             name_admin1: <><Modaleditexpertbn id_expertbn={data.id_expertbn} list={this.list} /></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />


        return (
            <MDBContainer fluid>
            <div>
        
            {localStorage.getItem('admin_type') === 'expertbn' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (บรรณาธิการ)</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
               <MDBAlert color="primary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
               
                  

                    <MDBRow >
                    <MDBCol md="8">
                    <PageHeader
                        className="site-page-header"
                      //  onBack={() => null}
                        title="ข้อมูลบรรณาธิการ"
                        subTitle="ข้อมูลบรรณาธิการ"
                        avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/5231/5231019.png' }}
                    />
                    </MDBCol>
                    <MDBCol md="4">
                    <Modaladdexpertbn iduser={localStorage.getItem('iduser')} list={this.list} />
                    </MDBCol>
                    </MDBRow>
   </MDBAlert>

              {persons}
                {/* <MDBTable responsive>
                    <MDBTableHead color='light'>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>สังกัดหน่วยงาน</th>
                        <th>ความเชียวชาญ</th>
                        <th>เบอร์โทร</th>
                        <th>ผู้เพิ่มข้อมูล</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_expertbn}</td>
                        <td>{article.username_expertbn}</td>
                        <td>{article.password_expertbn}</td>
                        <td>{article.affiliation_expertbn}</td>
                        <td>{article.expertise_expertbn}</td>
                        <td>{article.tel_expertbn}</td>
                        <td>{article.name_admin}</td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
